import { getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup, sendPasswordResetEmail, confirmPasswordReset } from "firebase/auth";
import { DocumentReference, setDoc } from "firebase/firestore";
import { produce } from 'immer';
import { ProfileInterface } from "ts-interfaces";   

export const sendResetPassword = (email: string) => { return sendPasswordResetEmail(getAuth(), email); };
export const resetPassword = (oobCode: string, password: string) => { return confirmPasswordReset(getAuth(), oobCode, password); };
export const generateID = () => { return Array.from(Array(10), () => Math.floor(Math.random() * 36).toString(36)).join(''); };

export async function getUserLocationFromIPdata(timeout: number = 500): Promise<any> {
    return new Promise((resolve, reject) => {
      const requestOptions: RequestInit = { method: 'GET' };
      if (AbortSignal?.timeout) { 
        requestOptions.signal = AbortSignal.timeout(timeout);
      }
      fetch('https://api.ipdata.co?api-key=d5a756a764e248854368e06ff31e506948471e7c40bffa73c0dde8c8', requestOptions)
        .then(response => response.json())
        .then(result => {
          if (window.sessionStorage && result?.currency?.code) {
            window.sessionStorage.setItem('currency', result?.currency?.code);
          }
          resolve(result);
        })
        .catch(error => { 
          console.log('user location err', error); 
          reject(error); 
        });
    });
  }
  
export const googleSignup = (): Promise<any> => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
        prompt: "select_account"
    });
    provider.addScope('profile');
    provider.addScope('email');
    return signInWithPopup(getAuth(), provider);
}

export const getErrorMessage = (message: string): string => {
    let errMessage = message;
    if (message.includes('popup-closed-by-user'))
        errMessage = 'Authentication popup closed too early';
    else if (message.includes('email-already-in-use'))
        errMessage = 'Email address is already registered with us. Please Sign in to continue.';
    else if (message.includes('auth/missing-email'))
        errMessage = 'Please enter email address';
    else if (message.includes("user-not-found"))
        errMessage = "Email address is not in our records";
    else if (message.includes("wrong-password"))
        errMessage = "Entered password does not match";
    else if (message.includes("weak-password"))
        errMessage = "Password should be at least 6 characters";
    return errMessage;
}

export const fetchData = async (requestData: any, url: string): Promise<any> => {
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        });
        if (!response.ok) {
            throw new Error('API request failed');
        }
        const responseData = await response.json();
        return responseData;        
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
}

export async function updateProfile(profile: ProfileInterface, pic: any = {}, firebaseRef: DocumentReference): Promise<ProfileInterface> {
    return new Promise((resolve, reject) => {
        if (!profile.id) throw new Error("Profile ID is required")
        if (profile.uid?.length < 4) throw new Error("Profile UID is required")
        if (profile.email?.length < 4) throw new Error("Profile Email is required")
        const updatedProfile = produce(profile, (draft: ProfileInterface) => {
            draft.updated_at = new Date()
        })      
        const unfrozenProfile = JSON.parse(JSON.stringify(updatedProfile))
        //unfortunate hack here.  uploadAndSave cannot support frozen data structures... better to do the fix here than there
        if (unfrozenProfile.createdAt && updatedProfile.createdAt) unfrozenProfile['createdAt'] = updatedProfile.createdAt
        if (unfrozenProfile.updated_at && updatedProfile.updated_at) unfrozenProfile['updatedAt'] = updatedProfile.updated_at
        if (unfrozenProfile.created_at && updatedProfile.created_at) unfrozenProfile['created_at'] = updatedProfile.created_at
            
        uploadAndSave2(firebaseRef, unfrozenProfile.id, unfrozenProfile.uid, unfrozenProfile, pic)
            .then(result => {
                resolve(unfrozenProfile);
            })
            .catch(error => { 
                reject(error); 
                console.log("error ", error); 
            })
    })      
}

export async function uploadAndSave2(firebaseRef: DocumentReference, id: string, uid: string, data: any, pic: any = {}): Promise<any> {
    return new Promise(async (resolve, reject) => {
        try {
            // setDoc with merge will create if doesn't exist, or update if it does
            await setDoc(firebaseRef, data, { merge: true });
            resolve(data);
        } catch (error) {
            reject(error);
        }
    });
}